import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

marked.setOptions({ gfm: true, breaks: true });

@Pipe({ name: 'markdown', standalone: true })
export class MarkdownPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  transform(value: string | null | undefined): SafeHtml {
    if (!value?.trim()) {
      return this.sanitizer.bypassSecurityTrustHtml('<p class="md-empty">—</p>');
    }
    const parsed = marked.parse(value, { async: false }) as string;
    const clean = DOMPurify.sanitize(parsed, {
      USE_PROFILES: { html: true }
    });
    return this.sanitizer.bypassSecurityTrustHtml(clean);
  }
}
